import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnchorBar, AnchorBarList, AnchorBarListItem } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './Navbar.module.scss';

const NavBar = () => {
    useStyles(stylesheet);

    const { t } = useTranslation();
    const [activeAnchor, setActiveAnchor] = useState<string | undefined>(undefined);

    const anchorLinks = [
        { id: 'ai-quality', title: t('Logomaker GenAi Landing Page > Nav Bar > AI Quality.value') },
        {
            id: 'simple-prompts',
            title: t('Logomaker GenAi Landing Page > Nav Bar > Simple Prompts.value'),
        },
        {
            id: 'more-for-free',
            title: t('Logomaker GenAi Landing Page > Nav Bar > More For Free.value'),
        },
        {
            id: 'how-it-works',
            title: t('Logomaker GenAi Landing Page > Nav Bar > How It Works.value'),
        },
    ];

    return (
        <AnchorBar
            sticky
            onActiveAnchorChanged={setActiveAnchor}
            paddingY={5}
            className={styles.navbar}
        >
            <AnchorBarList>
                {anchorLinks.map(({ id, title }) => (
                    <AnchorBarListItem key={`anchor-bar-list-item-${id}`}>
                        <a href={`#${id}`} aria-current={activeAnchor === id ? 'true' : undefined}>
                            {title}
                        </a>
                    </AnchorBarListItem>
                ))}
            </AnchorBarList>
        </AnchorBar>
    );
};

export default NavBar;
